"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginWrapper = void 0;
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var LoginPage_1 = __importDefault(require("./LoginPage"));
var AsperaCheck_1 = __importDefault(require("../components/AsperaCheck"));
var LoginWrapper = /** @class */ (function (_super) {
    __extends(LoginWrapper, _super);
    function LoginWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginWrapper.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LoginPage_1.default, { history: this.props.history, location: this.props.location, match: this.props.match }),
            react_1.default.createElement(AsperaCheck_1.default, { isInitializing: this.props.isLoggedOut ? false : true })));
    };
    return LoginWrapper;
}(react_1.Component));
exports.LoginWrapper = LoginWrapper;
var mapStateToProps = function (store) {
    return {
        isLoggedOut: react_device_detect_1.isIE ? true : store.auth.isLogoutInitiated || false
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(LoginWrapper);
